<template>
  <div class="export-task-status">
    <el-popover
      placement="bottom"
      trigger="click"
      v-model="visible"
      width="300"
      popper-class="export-task-status-popover"
    >
      <template #reference>
        <div class="status-indicator" @click="handleClick">
          <el-badge :value="taskCount" :max="99" :hidden="taskCount === 0">
            <i class="el-icon-download"></i>
          </el-badge>
          <div v-if="taskCount > 0" class="progress-indicator"></div>
        </div>
      </template>
      
      <div class="task-list">
        <div class="task-list-header">
          <span>导出任务状态</span>
          <el-button
            type="text"
            size="mini"
            @click="clearAllTasks"
            :disabled="taskCount === 0"
          >
            清除所有
          </el-button>
        </div>
        
        <div v-if="taskCount === 0" class="no-tasks">
          当前没有进行中的导出任务
        </div>
        
        <div v-else class="task-items">
          <div v-for="taskId in taskIds" :key="taskId" class="task-item">
            <div class="task-id">{{ taskId }}</div>
            <div class="task-status">处理中...</div>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'ExportTaskStatus',
  data() {
    return {
      visible: false,
      taskCount: 0,
      taskIds: []
    };
  },
  created() {
    // 监听任务更新事件
    this.$listenToExportTasks(this.updateTaskStatus);
    
    // 初始化任务状态
    this.updateTaskStatus({
      tasks: this.$taskPolling.getAllTaskIds(),
      taskCount: this.$taskPolling.getTaskCount()
    });
  },
  methods: {
    // 更新任务状态
    updateTaskStatus({ tasks, taskCount }) {
      this.taskCount = taskCount;
      this.taskIds = tasks;
      
      // 如果没有任务了，自动关闭弹窗
      if (taskCount === 0 && this.visible) {
        this.visible = false;
      }
    },
    
    // 点击事件处理
    handleClick() {
      // 如果有任务，手动触发一次轮询
      if (this.taskCount > 0) {
        // this.$pollExportTasks();
      }
    },
    
    // 清除所有任务
    clearAllTasks() {
      this.$confirm(
        '确定要清除所有导出任务吗？这将取消所有进行中的导出任务。',
        '清除导出任务',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$taskPolling.clearAllTasks();
        this.$message.success('已清除所有导出任务');
      }).catch(() => {
        // 取消操作，不做任何处理
      });
    }
  }
};
</script>

<style scoped lang="scss">
.export-task-status {
  display: inline-block;
  margin-right: 10px;
  
  .status-indicator {
    position: relative;
    cursor: pointer;
    padding: 0 10px;
    
    &:hover {
      color: var(--el-color-primary);
    }
    
    .progress-indicator {
      position: absolute;
      bottom: -5px;
      left: 10px;
      right: 10px;
      height: 2px;
      background-color: var(--el-color-primary);
      animation: progress 2s linear infinite;
      background: linear-gradient(90deg, transparent, var(--el-color-primary), transparent);
      background-size: 200% 100%;
    }
  }
  
  .task-list {
    .task-list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      padding-bottom: 5px;
      border-bottom: 1px solid var(--el-border-color-light);
      
      span {
        font-weight: bold;
      }
    }
    
    .no-tasks {
      color: var(--el-text-color-secondary);
      text-align: center;
      padding: 10px 0;
    }
    
    .task-items {
      max-height: 300px;
      overflow-y: auto;
      
      .task-item {
        padding: 8px 0;
        border-bottom: 1px dashed var(--el-border-color-lighter);
        
        .task-id {
          font-size: 12px;
          color: var(--el-text-color-secondary);
        }
        
        .task-status {
          font-size: 12px;
          color: var(--el-color-primary);
        }
      }
    }
  }
}

@keyframes progress {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>